import Skeleton from "components/ui/Skeleton";
import { Card } from "../../../components/ui";

/** Placeholder while the workspace calc is (re)computing for the first time. */
export default function TabSkeleton({ cards = 2 }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: cards }).map((_, i) => (
        <Card key={i} className="space-y-3 p-4">
          <Skeleton className="h-4 w-48" />
          <Skeleton.Rows rows={4} />
        </Card>
      ))}
    </div>
  );
}
